import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'AuthWidget' })({
    hidden: {
        display: 'none'
    }
});
